import React, { useState } from 'react';
import styles from './Form.module.css';
import { useTranslation } from 'react-i18next';
import { emailValidator } from '@utils/validators';
import { Button, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { Link, useNavigate } from 'react-router-dom';
import useAuth from '@hooks/useAuth/useAuth';

import { ApproveRecovery } from '@components/Approve';

const Form = () => {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [, { forget, sendAgain }] = useAuth();
  const [registerValues, setRegisterValues] = useState();

  const { t } = useTranslation();
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      email: '',
      company: '',
      name: '',
      termsOfService: false,
    },

    validate: {
      email: (value) => emailValidator(value, t)
    },
  });

  const onSuccess = (values) => {
    setRegisterValues(values)
  }

  const handleSubmit = async (values) => {
    const submitErrors = await forget(values, () => onSuccess(values));

    if (submitErrors?.length > 0) {
      submitErrors.forEach(error => {
        switch (error.code) {
          case 'P101':
            form.setErrors({
              email: t('login.error.notFound', { email: values.email })
            })

            break;

          default:
            break;
        }
      })
    }
  }

  const toRegister = () => {
    navigate('/log_in')
  }

  const sendAgaing = async () => {
    const email = registerValues.email
    await sendAgain({ email });
  }

  const handleBack = () => {
    setRegisterValues(null);
  }

  return (
    <div className={styles.wrapper}>
      {!registerValues && (
        <div>
          <div className={styles.title}>
            {t('forget.title')}
          </div>

          <div className={styles.description}>
            {t('forget.description')}
          </div>

          <form
            className={styles.form}
            onSubmit={form.onSubmit(handleSubmit)}
          >
            <TextInput
              label={t('email.label')}
              placeholder={t('email.placeholder')}
              key={form.key('email')}
              {...form.getInputProps('email')}
            />

            <div className={styles.separator} />

            <Button
              className={styles.button}
              fullWidth
              type="submit"
            >
              {t('recover')}
            </Button>

            <Link to='/log_in' className={styles.link}>
              <div className={styles.enter}>
                {t('enter')}
              </div>
            </Link>
          </form>
        </div>
      )}

      {registerValues && (
        <ApproveRecovery
          title={t('password.recovery')}
          email={registerValues.email}
          toRegister={toRegister}
          back={handleBack}
          sendAgaing={sendAgaing}
        />
      )}
    </div >
  )
}

export default Form;
